var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-autocomplete',_vm._g(_vm._b({attrs:{"fetch-suggestions":_vm.querySearch,"placeholder":"请选择"}},'el-autocomplete',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }